import { createContext, useContext } from 'react';

import type { AssignWizardContextValue } from 'pages/custom_tests/components/assign_wizard/AssignWizard';

export const AssignWizardContext = createContext({} as AssignWizardContextValue);
AssignWizardContext.displayName = 'AssignWizardContext';

export const useAssignWizard = () => useContext(AssignWizardContext);